import React, { Component } from 'react'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import _orderBy from 'lodash/orderBy'
// import { Link } from 'react-router-dom'
import { Layout, Col, Row, Button } from 'antd'

import CardObj from './Component/CardObj'
import HeaderTmp from '../Template/HeaderTmp'
import FooterTmp from '../Template/FooterTmp'
import SearchBar from './Component/SearchBar'
import './home.css'
// import Column from 'antd/lib/table/Column'

const { Content } = Layout

class Client extends Component {
  componentDidMount() {
    document.title = 'e-Slip - Powered By Thai.run'
  }

  render() {
    if (!this.props.data.events) {
      return <Button type="primary" shape="circle" loading style={{ marginLeft: '48%', marginTop: '22%' }} />
    }
    let { events } = this.props.data
    events = _orderBy(events, ['_id'], ['desc'])
    events = events.filter(event => event.eSlip !== false)
    // console.log(events)

    return (
      <Layout >
        <HeaderTmp />
        <Row type="flex" justify="center">
          <Col xs={24} sm={24} md={16} lg={16} xl={16} xxl={16} >
            <Content style={{
  marginTop: 96, minHeight: 'calc(100vh - 64px - 69px - 37px)', background: '#fff', textAlign: 'center',
}}
            >

              { events && events.map(event => (

                <CardObj name={event.title} event={event} key={event._id}>
                  <SearchBar event={event} />
                </CardObj>
                ))
              }

            </Content>
          </Col>
        </Row>
        <FooterTmp />
      </Layout>
    )
  }
}

const ClientQuery = gql`
    {
        events {
            event
            slug
            title
            partner
            logoImage
            date
            eSlip
            _id
        }
    }
`
const ClientWithData = graphql(ClientQuery)(Client)

export default ClientWithData



// WEBPACK FOOTER //
// ./src/Home/Home.js